import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { TextBlock, Text } from '~/shared/components';
import { breakpoints } from '~/theme';

export const StyledSection = styled(TextBlock.withComponent('section'))<{ separated?: boolean }>(
    ({ theme }) => ({
        marginBottom: theme.spaces[3],
        paddingBottom: theme.spaces[3],

        // Creates scroll to top offset
        paddingTop: theme.spaces[8],
        marginTop: `-${theme.spaces[8]}`,

        [breakpoints.md]: {
            maxWidth: 'clamp(900px, 85vw, 65%)',
            // Creates scroll to top offset
            paddingTop: theme.spaces[5],
            marginTop: `-${theme.spaces[5]}`,
        },
    }),
    ifProp('separated', ({ theme }) => ({
        borderBottom: theme.borders.border,
        marginBottom: theme.spaces[5],
        paddingBottom: theme.spaces[5],
        [breakpoints.md]: {
            marginBottom: theme.spaces[6],
            paddingBottom: theme.spaces[6],
        },
    }))
);

export const StyledBonusBadge = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.light30,
    maxWidth: 'fit-content',
    padding: `${theme.spaces[1]} ${theme.spaces[3]}`,
}));

export const StyledBonusText = styled(Text)(({ theme }) => ({
    fontSize: theme.fontSizes['4xl'],
}));

export const StyledEditContent = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: `${theme.spaces[6]} 0 `,
}));
